var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$store.getters.getUserToken)?_c('app-bar'):_vm._e(),_c('v-main',{style:({ background: _vm.$vuetify.theme.themes.light.background }),attrs:{"id":"main"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }